module.exports = __webpack_public_path__ + "img/2.518f3e4f.png";